import { SLIPS } from "../types";

export interface ISlips {
  t4:
    | {
        employeeId: string | null;
        provinceId: string | null;
        slipType: number;
      }
    | undefined;
  rl1:
    | {
        employeeId: string | null;
        provinceId: string | null;
        slipType: number;
      }
    | undefined;
}

const initialState: ISlips = {
  t4: undefined,
  rl1: undefined,
};

export const slipsReducer = (
  state: ISlips = initialState,
  action: any,
): ISlips => {
  switch (action.type) {
    case SLIPS.SLIPS_SET_SELECTED:
      return {
        ...state,
        t4: action.payload.t4,
        rl1: action.payload.rl1,
      };
    case SLIPS.SLIPS_CLEAR_SELECTED:
      return {
        ...state,
        t4: initialState.t4,
        rl1: initialState.rl1,
      };
    default:
      return state;
  }
};
